export enum FormInputTypeEnum {
  INPUTTER = 'inputter',
  SELECTOR = 'selector',
}
